/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

/**
 * Check if the given value is a plain object.
 */
export const isPlainObject = (obj: any): obj is Record<string, any> => {
  return obj !== null && typeof obj === 'object' && obj.constructor === Object;
};
